<script lang="ts">
	import Checkbox from "../../atoms/forms/Checkbox.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
</script>

<div class="{klass}">
 	<Checkbox
		label="表示する"
		on:click={service.handleDisabled}
		checked={!($model.disabled)}
	/>
</div>